import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PortalService } from '../portal.service';

@Component({
    selector: 'portal-login',
    templateUrl: './portal-login.component.html'
})
export class PortalLoginComponent implements OnInit {
    loading: boolean = false;
    modelLogin: any = {};
    public right_side_bar: boolean;
    constructor(public translate: TranslateService,
                private portalService: PortalService) { }
    ngOnInit() {
        
    }

    login() {
        this.portalService.login(this.modelLogin);
    }
}
